import { render, staticRenderFns } from "./HtmlTableItemPreview.vue?vue&type=template&id=0f25be7d&scoped=true&"
import script from "./HtmlTableItemPreview.vue?vue&type=script&lang=js&"
export * from "./HtmlTableItemPreview.vue?vue&type=script&lang=js&"
import style0 from "./HtmlTableItemPreview.vue?vue&type=style&index=0&id=0f25be7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f25be7d",
  null
  
)

export default component.exports